import React from 'react';
import { isIterable } from '../../utils/helpers/utils';
import { useDarkMode } from '../../utils/hooks/useDarkMode';
import { DesktopFooter, MobileFooter } from './footer';

/**
 * Footer Section Component
 * Main footer component that renders desktop and mobile versions
 * 
 * @param {Object} props
 * @param {Object} props.data - The footer data
 * @param {String} props.data.FooterDescription - Company description
 * @param {String} props.data.Copyrights - Copyright text
 * @param {Object} props.data.footerIcon - Company logo
 * @param {Array} props.data.rightBottomLinks - Legal links
 * @param {Array} props.data.LeftBottomLinks - Service links
 * @param {Array} props.data.socialIcons - Social media links
 * @param {Array} props.data.Address - Contact addresses
 * @param {String} props.data.hideMenu - Newline-separated page URLs where footer links are hidden
 * @param {String} props.pageUrl - Current page URL
 * @param {String} props.className - Optional additional CSS class
 */
const FooterSection = ({ data, pageUrl, className = '' }) => {
    const { isDarkMode } = useDarkMode();

    if (!data) return null;

    // Ensure Address is an array
    if (!isIterable(data.Address)) {
        data.Address = [data.Address];
    }

    const pagesUrls = data.hideMenu?.split(/\n/) ?? [];
    const foundHiddenPage = pagesUrls.find(url => url.trim() === pageUrl) || null;
    const isMenuVisible = foundHiddenPage ? false : true;

    return (
        <>
            <DesktopFooter 
                data={data} 
                isDarkMode={isDarkMode} 
                className={className}
                isMenuVisible={isMenuVisible}
            />
            <MobileFooter 
                data={data} 
                isDarkMode={isDarkMode} 
                className={className}
                isMenuVisible={isMenuVisible}
            />
        </>
    );
};

export default FooterSection;
